import React from "react"
import { Card, CardBody, CardTitle, Col, Container, Row } from "reactstrap"
import profile from "assets/images/profile-img.png"

// import images
import logodark from "../../assets/images/logo-dark.png"


const HelpPage = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row className="d-flex  justify-content-center">
            <Col xl={8}>
              <Card className="overflow-hidden">
                <div className="bg-primary bg-soft">
                  <Row>
                    <Col xs={7} className="padd-right-0">
                      <div className="text-primary p-4 padd-right-0">
                        <img
                          src={logodark}
                          alt=""
                          height="20"
                          className="auth-logo-dark mx-auto"
                        />
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>

                <CardBody className='mt-2'>
                  <div className='d-flex flex-column justify-content-center align-items-center'>
                    <a
                      href="https://tendersoft.sharepoint.com/:w:/r/sites/FlexiTrac-FeedbackandIssuesReporting/_layouts/15/Doc.aspx?sourcedoc=%7B870B30B3-DEB3-4844-AA31-A6ED2B61C6E8%7D&file=Flexi%20Trac%20Installation%20Guide.docx&action=default&mobileredirect=true"
                      target="_blank"
                      rel="noreferrer"
                      className='mt-3'
                    >
                      <CardTitle >Flexi Trac Installation Guide.docx</CardTitle>
                    </a>
                    <a
                      href="https://tendersoft.sharepoint.com/:v:/r/sites/FlexiTrac-FeedbackandIssuesReporting/Shared%20Documents/FlexiTrack%20Quick%20Tour.mp4?csf=1&web=1&e=oatpUIx"
                      target="_blank"
                      rel="noreferrer"
                      className='mt-4'

                    >
                      <CardTitle>Quick Tour Video</CardTitle>
                    </a>
                    <a
                      href="https://tendersoft.sharepoint.com/sites/FlexiTrac-FeedbackandIssuesReporting/Lists/Issue%20tracker/NewForm.aspx"
                      target="_blank"
                      rel="noreferrer"
                      className='mt-4'
                    >
                      <CardTitle>Bug Reporting</CardTitle>
                    </a>
                  </div>
                </CardBody>

              </Card>
              <div className="mt-5 text-center">
                <a
                  href="https://forms.office.com/Pages/ResponsePage.aspx?id=YETwgjFhjkmfm7eioEEcJWCMS5Jd9rdNr_JinaPZh9NUNzhHVlFOR0pCVEpOR0QxRzE2QkhFVE1FWC4u "
                  target="_blank"
                  rel="noreferrer"
                >
                  <p>Feedback Form</p>
                </a>
                <p>© {new Date().getFullYear()} TenderSoftware.</p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default HelpPage
